import { createContext, useContext, useReducer } from "react";
import { InitialState } from "./initialState";
import Reducers from "./reducers";

const Context = createContext(null);
const ContextDispatcher = createContext(null);

export function ContextProvider({ children }) {
  const [state, dispatch] = useReducer(Reducers, InitialState);
  return (
    <Context.Provider value={state}>
      <ContextDispatcher.Provider value={dispatch}>
        {children}
      </ContextDispatcher.Provider>
    </Context.Provider>
  );
}

export function useAppState() {
  return {
    config: useContext(Context)?.config || {},
    session: useContext(Context)?.session,
    tradeData: useContext(Context)?.tradeData,
    pageState: useContext(Context)?.pageState,
    theme: useContext(Context)?.theme,
    jobFeedLog: useContext(Context)?.jobFeedLog ?? "",
    updateStore: useContext(ContextDispatcher),
  };
}
